import { useState } from 'react';
import { useAddressesByPostcode } from '../../../../queries';

export const useAddressFormProps = () => {
  const [postcode, setPostcode] = useState('');

  const {
    data: addressOptions = [],
    refetch: fetchAddressesByPostcode,
    isFetching,
    error,
  } = useAddressesByPostcode(postcode);

  return {
    setPostcode,
    postcode,
    isFetching,
    error,
    fetchAddressesByPostcode,
    addressOptions,
  };
};
